const sortByDate = (a, b) => new Date(b.sortBy).getTime() - new Date(a.sortBy).getTime();

const supportedEdgeVersions = [15, 16, 18];

const getIEVersion = () => {
  const uaString = navigator.userAgent;
  const match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(uaString);
  if (match) return parseInt(match[2], 10);
  return null;
};

const isEdge = navigator.userAgent.indexOf('Edge') >= 0;

const isUnsupportedBrowser = () => {
  if (isEdge) {
    const ieVersion = getIEVersion();
    return ieVersion
      && !(Number.isNaN(ieVersion))
      && !supportedEdgeVersions.includes(ieVersion);
  }
  return false;
};

const strHasValue = str => str && str.length > 0;

const tryParseInt = (str) => {
  const isNum = str !== null && str.length && !Number.isNaN(str);
  return isNum ? parseInt(str, 10) : null;
};

const getUrlParam = (param) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(param);
};

const getUrlNum = param => tryParseInt(getUrlParam(param));

/**
 * @description
 * Takes an Array<V>, and a grouping function,
 * and returns an Array converted from a Map of the array grouped by the grouping function.
 *
 * @param list An array of type V.
 * @param keyGetter A Function that takes the the Array type V as an input, and returns a value of type K.
 *                  K is generally intended to be a property key of V.
 *
 * @returns Array converetd from the Map of the array grouped by the grouping function.
 */
//export function groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K): Map<K, Array<V>> {
//    const map = new Map<K, Array<V>>();
const arrayGroupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
       const key = keyGetter(item);
       const collection = map.get(key);
       if (!collection) {
           map.set(key, [item]);
       } else {
           collection.push(item);
       }
  });
  return Array.from(map.values()).map(a => a[0]);
};

const emptyPlaceholderWhenNoData = (data) => {
  if (data === undefined || data === null) {
    return '';
  }
  return data;
};

const isValidGuid = (guid) => {
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(guid);
};

export default {
  isUnsupportedBrowser,
  sortByDate,
  strHasValue,
  tryParseInt,
  getUrlParam,
  getUrlNum,
  arrayGroupBy,
  emptyPlaceholderWhenNoData,
  isValidGuid,
};
